// English (default) translations.
// Keys use kebab.dot.case grouped by domain.
// Use {{var}} for interpolation.
const en = {
  // Common
  "common.cancel": "Cancel",
  "common.save": "Save",
  "common.delete": "Delete",
  "common.edit": "Edit",
  "common.close": "Close",
  "common.confirm": "Confirm",
  "common.search": "Search",
  "common.loading": "Loading...",
  "common.actions": "Actions",
  "common.status": "Status",
  "common.name": "Name",
  "common.email": "Email",
  "common.phone": "Phone",
  "common.role": "Role",
  "common.active": "Active",
  "common.blocked": "Blocked",
  "common.yes": "Yes",
  "common.no": "No",
  "common.back": "Back",
  "common.next": "Next",
  "common.submit": "Submit",
  "common.create": "Create",
  "common.add": "Add",
  "common.update": "Update",
  "common.welcome": "Welcome",
  "common.signOut": "Sign Out",
  "common.signIn": "Sign In",
  "common.demo": "Demo",
  "common.readOnly": "Read-only",
  "common.welcomeBack": "Welcome back",
  "common.priority": "Priority",
  "common.category": "Category",
  "common.building": "Building",
  "common.assignedTo": "Assigned To",
  "common.created": "Created",
  "common.unassigned": "Unassigned",
  "common.all": "All",
  "common.portfolio": "Portfolio",
  "common.allBuildings": "All buildings (Portfolio)",

  // Dashboard
  "dash.welcome": "Welcome back, {{name}}!",
  "dash.subtitle": "Here's what's happening with your facilities today",
  "dash.totalBuildings": "Total Buildings",
  "dash.openComplaints": "Open Complaints",
  "dash.inProgress": "In Progress",
  "dash.resolvedToday": "Resolved Today",
  "dash.pendingPpm": "Pending PPM Tasks",
  "dash.overdueTasks": "Overdue Tasks",
  "dash.lowStock": "Low Stock Items",
  "dash.expiringCerts": "Expiring Certificates",
  "dash.complaintsByStatus": "Complaints by Status",
  "dash.complaintsByCategory": "Complaints by Category",
  "dash.perBuilding": "Complaints — Per Building Breakdown",
  "dash.utilityTrend": "Utility Consumption Trend",

  // Complaints
  "comp.title": "Complaints",
  "comp.subtitle": "Manage tenant complaints and maintenance requests",
  "comp.new": "New Complaint",
  "comp.status.open": "Open",
  "comp.status.assigned": "Assigned",
  "comp.status.in_progress": "In Progress",
  "comp.status.resolved": "Resolved",
  "comp.status.closed": "Closed",
  "comp.priority.low": "Low",
  "comp.priority.medium": "Medium",
  "comp.priority.high": "High",
  "comp.priority.urgent": "Urgent",
  "comp.category.hvac": "HVAC",
  "comp.category.plumbing": "Plumbing",
  "comp.category.electrical": "Electrical",
  "comp.category.maintenance": "Maintenance",
  "comp.category.security": "Security",
  "comp.category.cleaning": "Cleaning",
  "comp.category.other": "Other",

  // Buildings
  "bldg.title": "Buildings",
  "bldg.subtitle": "Manage your company's building portfolio",
  "bldg.add": "Add Building",
  "bldg.floors": "Floors",
  "bldg.units": "Units",
  "bldg.totalArea": "Total Area",

  // PPM Tasks
  "ppm.title": "PPM Tasks",
  "ppm.subtitle": "Preventive maintenance tasks and due-date tracking",
  "ppm.new": "New PPM Task",

  // Schedules
  "sched.title": "Work Schedules",
  "sched.subtitle": "Recurring schedules with automated reminders and renewal",
  "sched.new": "New Schedule",

  // Assets
  "asset.title": "Asset Register",
  "asset.subtitle": "Equipment inventory with QR codes and maintenance tracking",
  "asset.add": "Add Asset",
  "asset.scanQR": "Scan QR",
  "asset.stopScan": "Stop Scan",
  "asset.downloadPDF": "Download PDF",

  // Suppliers
  "supp.title": "Suppliers",
  "supp.subtitle": "Service providers and vendor directory",
  "supp.add": "Add Supplier",

  // Tenants
  "tenant.title": "Tenants",
  "tenant.subtitle": "Tenant directory and lease information",
  "tenant.add": "Add Tenant",

  // Staff
  "staff.title": "Staff Directory",
  "staff.subtitle": "FM team members and contact information",
  "staff.add": "Add Staff",

  // Certificates
  "cert.title": "Statutory Certificates",
  "cert.subtitle": "Compliance certificates, renewals and expiry tracking",
  "cert.add": "Add Certificate",

  // Notices
  "notice.title": "Notices",
  "notice.subtitle": "Company-wide announcements and circulars",
  "notice.new": "Post Notice",

  // Contacts
  "contact.title": "Contacts Directory",
  "contact.subtitle": "Emergency contacts and key personnel",
  "contact.add": "Add Contact",

  // Stock
  "stock.title": "Stock & Inventory",
  "stock.subtitle": "Materials, spares and consumables",
  "stock.totalValue": "Total value",
  "stock.registerPDF": "Stock Register PDF",
  "stock.newItem": "New Item",
  "stock.auditLog": "Audit Log",
  "stock.unitCost": "Unit",
  "stock.value": "Value",

  // Stock Movements
  "mv.title": "Stock Movement Audit",
  "mv.subtitle": "Full audit trail of every stock receipt, issue, adjustment and return — for reconciliation & compliance.",
  "mv.manual": "Manual Movement",
  "mv.auditPDF": "Audit PDF",
  "mv.movements": "Movements",
  "mv.totalIn": "Total IN (value)",
  "mv.totalOut": "Total OUT (value)",
  "mv.netChange": "Net change",
  "mv.noData": "No movements yet",

  // AMC
  "amc.title": "AMC Contracts",
  "amc.subtitle": "Annual Maintenance Contracts and scope tracking — link PPM tasks for compliance scoring.",
  "amc.new": "New Contract",
  "amc.compliance": "Compliance",

  // Provider KPI
  "kpi.title": "Service Provider KPI",
  "kpi.subtitle": "Compliance scoring based on AMC scope completion and SLA hit rate. Composite KPI = 60% completion + 40% SLA.",
  "kpi.score": "KPI Score",
  "kpi.completion": "Completion",
  "kpi.slaHit": "SLA Hit",
  "kpi.overdue": "Overdue",
  "kpi.aiEval": "AI Evaluation",

  // Custom Reports
  "creport.title": "Custom Reports",
  "creport.subtitle": "Build, save, download and print branded PDF reports with your company letterhead.",
  "creport.new": "New Report",
  "creport.noSaved": "No saved reports yet",

  // Help
  "help.title": "User Guide",
  "help.subtitle": "Step-by-step workflows, training manuals and support contacts",

  // Brand
  "brand.tagline": "by SKG Apps",
  "brand.appName": "FM Flexi Pro",

  // Auth
  "auth.signInTitle": "Sign in to your workspace",
  "auth.signInSubtitle": "Use the credentials provided by your administrator.",
  "auth.password": "Password",
  "auth.continueWithGoogle": "Continue with Google",
  "auth.signInWithEmail": "Sign In with Email",
  "auth.tryDemo": "Try Demo (read-only)",
  "auth.firstLoginNote": "If this is your first login, you'll be prompted to set a new password.",
  "auth.changePasswordTitle": "Set your new password",
  "auth.changePasswordSubtitle": "Your account uses a temporary password. Please set a permanent password to continue.",
  "auth.currentPassword": "Current password",
  "auth.newPassword": "New password",
  "auth.confirmPassword": "Confirm new password",
  "auth.savePassword": "Save new password",
  "auth.passwordMismatch": "Passwords do not match.",
  "auth.passwordMinLength": "Password must be at least 8 characters.",
  "auth.signedInAs": "Signed in as",

  // Navigation / Modules
  "nav.dashboard": "Dashboard",
  "nav.myWork": "My Work / Technician KPI",
  "nav.buildings": "Buildings",
  "nav.assets": "Assets",
  "nav.complaints": "Complaints",
  "nav.ppm": "PPM Tasks",
  "nav.schedules": "Schedules",
  "nav.analytics": "Analytics",
  "nav.staff": "Staff",
  "nav.attendance": "Attendance",
  "nav.contacts": "Contacts",
  "nav.notices": "Notices",
  "nav.sops": "SOPs & SLAs",
  "nav.serviceReports": "Service Reports",
  "nav.suppliers": "Suppliers",
  "nav.amcContracts": "AMC Contracts",
  "nav.providerKpi": "Provider KPI",
  "nav.workOrders": "Work Orders",
  "nav.technicianKpi": "Technician KPI",
  "nav.executive": "Executive",
  "nav.finance": "Finance",
  "nav.purchases": "Purchases",
  "nav.stock": "Stock",
  "nav.stockMovements": "Stock Audit",
  "nav.tenants": "Tenants",
  "nav.certificates": "Certificates",
  "nav.utilities": "Utilities",
  "nav.aiInsights": "AI Insights",
  "nav.accounting": "Accounting",
  "nav.hr": "HR",
  "nav.users": "Users",
  "nav.companies": "Companies",
  "nav.customReports": "Custom Reports",
  "nav.auditLogs": "Audit Log",
  "nav.backups": "Backups",
  "nav.roleAccess": "Role Access",
  "nav.subscription": "Subscription",
  "nav.help": "User Guide",
  "nav.settings": "Settings",
  "nav.more": "More",
  "nav.superadmin": "Super Admin Dashboard",
  "nav.notes": "Notes & Reminders",
  "nav.advAccounting": "Advanced Accounting",
  "nav.quotations": "Quotations",
  "nav.vouchers": "Vouchers",
  "nav.lpo": "LPO Preparation",
  "nav.procurement": "Delivery & Payments",
  "nav.spDashboard": "Sales/Purchase PnL",
  "nav.ppmCalendar": "PPM Calendar",
  "nav.housekeeping": "Housekeeping",
  "nav.jobOrders": "Job Orders",
  "nav.supplierDashboard": "Supplier Dashboard",
  "nav.vault": "Document Vault",
  "nav.workflows": "Workflows",

  // Menu group headers
  "group.overview": "Overview",
  "group.complaintWorkflow": "Complaint Workflow",
  "group.operations": "Operations",
  "group.people": "People",
  "group.finance": "Finance & Accounts",
  "group.procurement": "Procurement",
  "group.security": "Security",
  "group.compliance": "Compliance",
  "nav.secIncidents": "Incidents",
  "nav.secPatrols": "Patrol Log",
  "nav.secVisitors": "Visitor Log",
  "nav.secMaintVisits": "Maintenance Visits",
  "nav.secKeys": "Key Register",
  "group.insights": "Insights",
  "group.admin": "Administration",

  // Common tab labels (shared across pages)
  "tab.invoices": "Invoices",
  "tab.bills": "Supplier Bills",
  "tab.payments": "Payments",
  "tab.aging": "Aging Report",
  "tab.leaves": "Leave Requests",
  "tab.payroll": "Payroll",
  "tab.accounts": "Bank & Cash",
  "tab.coa": "Chart of Accounts",
  "tab.advances": "Advance Payments",
  "tab.returns": "Purchase Returns",
  "tab.pnl": "Profit & Loss",
  "tab.notes": "Notes",
  "tab.reminders": "Reminders",
  "tab.complaintFlow": "Complaint Lifecycle",
  "tab.providerFlow": "Service Provider PPM",

  // Accounting page
  "accounting.subtitle": "Invoices, supplier bills, payments, and cash-flow health.",
  "accounting.ar": "Accounts Receivable",
  "accounting.arOverdue": "A/R Overdue",
  "accounting.ap": "Accounts Payable",
  "accounting.apOverdue": "A/P Overdue",
  "accounting.invoicesCount": "{{count}} invoices · {{outstanding}} outstanding",
  "accounting.billsCount": "{{count}} bills · {{outstanding}} outstanding",
  "accounting.pastDueInvoices": "Past due invoices",
  "accounting.owedPastDue": "Owed past due",
  "accounting.noInvoices": "No invoices yet.",
  "accounting.noBills": "No bills yet.",
  "accounting.noPayments": "No payments recorded.",
  "accounting.loading": "Loading…",
  "accounting.allBuildings": "All buildings",
  "accounting.dateFrom": "From date",
  "accounting.dateTo": "To date",
  "accounting.clearFilters": "Clear filters",
  "accounting.recordPayment": "Record payment",
  "accounting.markPaid": "Mark paid",
  "accounting.newSupplierBill": "New Supplier Bill",
  "accounting.recordPaymentTitle": "Record Payment",
  "accounting.invoiceNumber": "Invoice number",
  "accounting.billNumber": "Bill number",
  "accounting.customer": "Customer",
  "accounting.supplier": "Supplier",
  "accounting.building": "Building",
  "accounting.issueDate": "Issue date",
  "accounting.dueDate": "Due date",
  "accounting.amount": "Amount",
  "accounting.tax": "Tax",
  "accounting.description": "Description",
  "accounting.method": "Method",
  "accounting.reference": "Reference",
  "accounting.directionIn": "Incoming (invoice payment)",
  "accounting.directionOut": "Outgoing (bill payment)",
  "accounting.directionLabel": "Direction",
  "accounting.method.bank": "Bank",
  "accounting.method.cash": "Cash",
  "accounting.method.card": "Card",
  "accounting.method.cheque": "Cheque",
  "accounting.arAging": "A/R Aging (Receivables)",
  "accounting.apAging": "A/P Aging (Payables)",
  "accounting.aging.current": "Current",
  "accounting.aging.1_30": "1–30 days",
  "accounting.aging.31_60": "31–60 days",
  "accounting.aging.61_90": "61–90 days",
  "accounting.aging.over_90": "Over 90 days",
  // Table headers
  "th.number": "#",
  "th.customer": "Customer",
  "th.supplier": "Supplier",
  "th.issue": "Issue",
  "th.due": "Due",
  "th.total": "Total",
  "th.paid": "Paid",
  "th.status": "Status",
  "th.date": "Date",
  "th.direction": "Direction",
  "th.reference": "Reference",
  "th.method": "Method",
  "th.amount": "Amount",
  "th.employee": "Employee",
  "th.type": "Type",
  "th.from": "From",
  "th.to": "To",
  "th.days": "Days",
  "th.reason": "Reason",
  "th.monthYear": "Month/Year",
  "th.basic": "Basic",
  "th.allowances": "Allowances",
  "th.ot": "OT",
  "th.deductions": "Deductions",
  "th.net": "Net",
  // Status badges
  "status.draft": "Draft",
  "status.sent": "Sent",
  "status.paid": "Paid",
  "status.overdue": "Overdue",
  "status.partial": "Partial",
  "status.unpaid": "Unpaid",
  "status.cancelled": "Cancelled",
  "status.pending": "Pending",
  "status.approved": "Approved",
  "status.rejected": "Rejected",
  "status.in": "IN",
  "status.out": "OUT",
  // HR page
  "hr.subtitle": "Leave requests, payroll, and people operations.",
  "hr.requestLeave": "Request Leave",
  "hr.newPayroll": "New Payroll Record",
  "hr.pendingLeaves": "Pending Leaves",
  "hr.awaitingDecision": "awaiting decision",
  "hr.approvedYtd": "Approved Days YTD",
  "hr.totalRequests": "{{count}} total requests",
  "hr.payrollYtd": "Payroll YTD Paid",
  "hr.recordsThisYear": "{{count}} records this year",
  "hr.pendingPayroll": "Pending Payroll",
  "hr.awaitingApproval": "awaiting approval",
  "hr.noLeaves": "No leave requests.",
  "hr.noPayroll": "No payroll records.",
  "hr.requestLeaveTitle": "Request Leave",
  "hr.newPayrollTitle": "New Payroll Record",
  "hr.leaveType": "Type",
  "hr.reason": "Reason",
  "hr.month": "Month",
  "hr.year": "Year",
  "hr.basicSalary": "Basic salary",
  "hr.netSalaryPreview": "Net salary will be: ",
  "hr.leaveTypes.annual": "Annual",
  "hr.leaveTypes.sick": "Sick",
  "hr.leaveTypes.unpaid": "Unpaid",
  "hr.leaveTypes.casual": "Casual",
  "hr.leaveTypes.other": "Other",
  "hr.saving": "Saving…",

  // Common action/page labels used across many modules
  "common.newInvoice": "New Invoice",
  "common.newBill": "New Bill",
  "common.addNew": "Add New",
  "common.edit": "Edit",
  "common.delete": "Delete",
  "common.view": "View",
  "common.download": "Download",
  "common.downloadPdf": "Download PDF",
  "common.duplicate": "Duplicate",
  "common.approve": "Approve",
  "common.reject": "Reject",
  "common.cancel": "Cancel",
  "common.save": "Save",
  "common.search": "Search",
  "common.filter": "Filter",
  "common.status": "Status",
  "common.date": "Date",
  "common.amount": "Amount",
  "common.total": "Total",
  "common.actions": "Actions",
  "common.notes": "Notes",
  "common.loggedInAs": "Logged in as",
  "common.allModules": "All Modules",
  "role.SUPERADMIN": "Super Admin",
  "role.FULL_ACCESS": "User Admin (Full Access)",
  "role.ADMIN": "Admin",
  "role.CEO": "CEO",
  "role.MANAGER": "Manager",
  "role.ACCOUNTANT": "Accountant",
  "role.PROCUREMENT_OFFICER": "Procurement Officer",
  "role.HR_MANAGER": "HR Manager",
  "role.STOREKEEPER": "Storekeeper",
  "role.SECURITY_OFFICER": "Security Officer",
  "role.CS_SUPERVISOR": "Customer Service Supervisor",
  "role.ENGINEER": "Engineer / Supervisor",
  "role.TECHNICIAN": "Technician",
  "role.TENANT": "Tenant",

  // Settings
  "settings.title": "Company Settings",
  "settings.subtitle": "Company details and branding (logo appears on all PDF reports)",
  "settings.branding": "Branding",
  "settings.companyLogo": "Company Logo",
  "settings.uploadLogo": "Upload Logo",
  "settings.logoHint": "PNG or JPG · max 500KB · square logo recommended",
  "settings.language": "Language & Localization",
  "settings.enableArabic": "Enable Arabic (العربية)",
  "settings.arabicHelp": "When enabled, all users in this company will see a language switcher in the top bar, and can use the app in Modern Standard Arabic with right-to-left layout. AI-generated insights will also respond in the active language.",
  "settings.companyDetails": "Company Details",
  "settings.companyName": "Company Name",
  "settings.address": "Address",
  "settings.contactEmail": "Contact Email",
  "settings.contactPhone": "Contact Phone",
  "settings.plan": "Plan",
  "settings.currencyCode": "Currency Code",
  "settings.displaySymbol": "Display Symbol",
  "settings.saveSettings": "Save Settings",

  // Users
  "users.title": "User Management",
  "users.subtitle": "Create staff accounts (Supervisor, Security, Engineer, Manager, etc.) — system auto-generates a one-time password.",
  "users.createUser": "Create User",
  "users.createStaffAccount": "Create staff account",
  "users.tempPasswordHint": "A one-time temporary password will be auto-generated. Share it with the user — they'll change it on first login.",
  "users.fullName": "Full Name",
  "users.createGenerate": "Create & Generate Temp Password",
  "users.accountCreated": "Account Created",
  "users.savePasswordWarning": "Save this temporary password now. It will not be shown again. Share it with the user — they must change it on first login.",
  "users.tempPassword": "Temporary password",
  "users.copyLoginDetails": "Copy login details",
  "users.savedClose": "I've saved it — close",
  "users.resetPassword": "Reset password",
  "users.blockUser": "Block user",
  "users.unblockUser": "Unblock user",
  "users.deleteUser": "Delete user",
  "users.tempBadge": "TEMP",
  "users.noUsers": "No users yet",
  "users.confirmBlock": "Block this user? They will be signed out and unable to log in.",
  "users.confirmReset": "Generate a new temporary password? The user will be signed out and forced to change it on next login.",
  "users.confirmDelete": "Delete this user? This cannot be undone.",

  // Language
  "lang.english": "English",
  "lang.arabic": "العربية",
  "lang.switchTo": "Switch language",
};

export default en;
